import { render, staticRenderFns } from "./serviceOrderSplit.vue?vue&type=template&id=0e207fe4&scoped=true&"
import script from "./serviceOrderSplit.vue?vue&type=script&lang=js&"
export * from "./serviceOrderSplit.vue?vue&type=script&lang=js&"
import style0 from "./serviceOrderSplit.vue?vue&type=style&index=0&id=0e207fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e207fe4",
  null
  
)

export default component.exports